(function() {
  'use strict';

  var sequence = 0;
  var pending = false;
  var forms = new Map();
  var closedForms = new Set();

  function stop(form) {
    var state = forms.get(form);
    if (!state) return;
    state.observer.disconnect();
    clearTimeout(state.timeout);
    forms.delete(form);
  }

  function enhance(form) {
    if (!form.isConnected) { stop(form); return false; }
    if (form.querySelector('.KlaviyoExclusions')) { stop(form); return true; }
    var template = document.getElementById('klaviyo-exclusions-template');
    var labels = form.querySelectorAll('.ql-font-poppins');
    var anchor = Array.prototype.find.call(labels, function(label) { return /exclusions?\s+apply/i.test(label.textContent); }) || labels[9];
    if (!template || !anchor) return false;
    var content = template.content.cloneNode(true);
    var button = content.querySelector('button');
    var text = content.querySelector('p');
    text.id = 'klaviyo-exclusions-' + (++sequence);
    button.setAttribute('aria-controls', text.id);
    button.addEventListener('click', function() {
      text.hidden = !text.hidden;
      button.setAttribute('aria-expanded', String(!text.hidden));
    });
    var container = anchor.closest('[data-testid="form-component"]');
    if (container) container.appendChild(content);
    else anchor.parentNode.insertBefore(content, anchor.nextSibling);
    stop(form);
    return true;
  }

  function reconcile() {
    pending = false;
    forms.forEach(function(state, form) { if (!form.isConnected) stop(form); });
    document.querySelectorAll('form.klaviyo-form').forEach(function(form) {
      if (closedForms.has(form.getAttribute('data-testid'))) return;
      if (enhance(form) || forms.has(form)) return;
      var observer = new MutationObserver(function() { enhance(form); });
      var timeout = setTimeout(function() { stop(form); }, 5000);
      forms.set(form, {observer: observer, timeout: timeout});
      observer.observe(form, {childList: true, subtree: true, characterData: true});
    });
  }

  window.addEventListener('klaviyoForms', function(event) {
    if (!event.detail) return;
    if (event.detail.type === 'close') {
      closedForms.add('klaviyo-form-' + event.detail.formId);
      forms.forEach(function(state, form) {
        if (form.getAttribute('data-testid') === 'klaviyo-form-' + event.detail.formId) stop(form);
      });
    } else if (['open', 'embedOpen', 'stepSubmit'].indexOf(event.detail.type) !== -1) {
      closedForms.delete('klaviyo-form-' + event.detail.formId);
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(reconcile);
    }
  });
  reconcile();
})();
